export default "__VITE_ASSET__CSpiNW9W__"